/**
 * WFW-013 — UpCart Figma parity. UpCart lives in an open shadow root (#upCart); theme CSS cannot
 * reach it. Inject wyde-upcart-figma.css into shadowRoot and query #UpcartPopup inside.
 */
(function () {
  if (window.__WYDE_UPCART_FIGMA__) return;
  window.__WYDE_UPCART_FIGMA__ = true;

  var CFG = window.__WYDE_AMP_FIGMA__ || {};
  var DEFAULT_THRESHOLDS = { USD: 20000, SEK: 50000, EUR: 10000, GBP: 13500, NOK: 200000 };

  var USP_IMG = {
    calendar:
      'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/Group_2.png?v=1778502922',
    shield: 'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/img_2.png?v=1775659357',
    klarna:
      'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/klarna-637a076e_svg.png?v=1775659388'
  };

  var PAY_CARD_IMG = {
    visa:
      'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/visa-65d650f7_svg.svg?v=1775660368',
    amex:
      'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/american_express-1efdc6a3_svg.svg?v=1775660375',
    mc: 'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/master-54b5a7ce_svg.svg?v=1775660382',
    apple:
      'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/apple_pay-1721ebad_svg.svg?v=1775660392',
    google:
      'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/google_pay-34c30515_svg.svg?v=1775660398',
    paypal:
      'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/paypal-a7c68b85_svg.svg?v=1775660405',
    shop: 'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/shopify_pay-925ab76d_svg.svg?v=1775660410'
  };

  var COPY = {
    en: {
      usp: [
        { text: '30-day easy returns', icon: 'calendar' },
        { text: 'Secure checkout', icon: 'shield' },
        { text: 'Buy now, pay later', icon: 'klarna' }
      ],
      progressRemainingHtml: function (money) {
        return 'Add <strong>' + money + '</strong> more to get Free Shipping';
      },
      progressDone:
        'Your order qualifies for <span class="wyde-amp-figma-rewards-accent">Free Shipping</span>',
      discount_title: 'Have a coupon? Use it now!',
      discount_placeholder: 'Discount code',
      shipping_label: 'Shipping',
      shipping_at_checkout: 'Calculated at checkout',
      shipping_free: 'Free',
      checkout_label: 'Proceed to a secure checkout',
      sizeLine: function (label) {
        return 'Size: ' + label;
      }
    },
    sv: {
      usp: [
        { text: '30 dagars enkel retur', icon: 'calendar' },
        { text: 'Säker kassa', icon: 'shield' },
        { text: 'Köp nu, betala senare', icon: 'klarna' }
      ],
      progressRemainingHtml: function (money) {
        return 'Lägg till <strong>' + money + '</strong> till för att få fri frakt';
      },
      progressDone:
        'Din beställning kvalificerar sig för <span class="wyde-amp-figma-rewards-accent">fri frakt</span>',
      discount_title: 'Har du en rabattkod? Använd den nu!',
      discount_placeholder: 'Rabattkod',
      shipping_label: 'Frakt',
      shipping_at_checkout: 'Beräknas i kassan',
      shipping_free: 'Gratis',
      checkout_label: 'Fortsätt till säker kassa',
      sizeLine: function (label) {
        return 'Storlek: ' + label;
      }
    }
  };

  function detectLang() {
    if (CFG.locale && COPY[CFG.locale]) return CFG.locale;
    var h = document.documentElement.getAttribute('lang') || '';
    if (/^sv\b/i.test(h)) return 'sv';
    return 'en';
  }

  function strings() {
    var lang = detectLang();
    return COPY[lang] || COPY.en;
  }

  function thresholdFor(currency) {
    var t = CFG.thresholds && CFG.thresholds[currency];
    if (t != null) return t;
    return DEFAULT_THRESHOLDS[currency] != null ? DEFAULT_THRESHOLDS[currency] : null;
  }

  function cartJsUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart.js?t=' + Date.now();
  }

  /** Pre-discount subtotal — free-shipping threshold must not read 0 when a coupon is applied. */
  function cartValueForFreeShipping(cart) {
    if (!cart) return 0;
    if (cart.items_subtotal_price != null) return cart.items_subtotal_price;
    if (cart.original_total_price != null) return cart.original_total_price;
    return cart.total_price || 0;
  }

  function formatCartMoney(cart, amountCents) {
    var amount = amountCents / 100;
    var lang = detectLang();
    if (cart.currency === 'SEK') {
      return (
        new Intl.NumberFormat(lang === 'sv' ? 'sv-SE' : undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(amount) + ' kr'
      );
    }
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: cart.currency
    }).format(amount);
  }

  function subtotalCentsFromCart(cart) {
    if (!cart) return 0;
    if (cart.items_subtotal_price != null && cart.items_subtotal_price > 0) {
      return cart.items_subtotal_price;
    }
    if (cart.original_total_price != null && cart.original_total_price > 0) {
      return cart.original_total_price;
    }
    if (cart.items && cart.items.length) {
      var sum = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        sum += item.final_line_price != null ? item.final_line_price : item.line_price || 0;
      }
      if (sum > 0) return sum;
    }
    return cart.total_price || 0;
  }

  var lastCartSnapshot = null;
  var syncingFooterTotals = false;

  function findCheckoutButton(popup) {
    return (
      popup.querySelector('a.upcart-checkout-button') ||
      popup.querySelector('a[class*="checkout-button"]')
    );
  }

  function syncCheckoutLabel(popup) {
    if (!popup) return;
    var checkoutBtn = findCheckoutButton(popup);
    if (!checkoutBtn) return;
    var pack = strings();
    if (
      checkoutBtn.getAttribute('data-wyde-upcart-checkout-label') === '1' &&
      checkoutBtn.textContent === pack.checkout_label
    ) {
      return;
    }
    syncingFooterTotals = true;
    try {
      checkoutBtn.textContent = pack.checkout_label;
      checkoutBtn.setAttribute('data-wyde-upcart-checkout-label', '1');
    } finally {
      syncingFooterTotals = false;
    }
  }

  function syncSubtotalLabel(popup, cart) {
    if (!popup || !cart || cart.item_count <= 0) return;
    var subtotalEl =
      popup.querySelector('[class*="cartSubtotalValue"]') ||
      popup.querySelector('.styles_Footer__cartSubtotalValue__');
    if (!subtotalEl) return;
    var subtotalCents = subtotalCentsFromCart(cart);
    if (subtotalCents <= 0) return;
    var formatted = formatCartMoney(cart, subtotalCents);
    if (subtotalEl.textContent === formatted && subtotalEl.getAttribute('data-wyde-upcart-subtotal-synced') === '1') {
      return;
    }
    syncingFooterTotals = true;
    try {
      subtotalEl.textContent = formatted;
      subtotalEl.setAttribute('data-wyde-upcart-subtotal-synced', '1');
    } finally {
      syncingFooterTotals = false;
    }
  }

  function syncFooterTotals(popup, cart) {
    if (!popup || !cart) return;
    lastCartSnapshot = cart;
    syncSubtotalLabel(popup, cart);
    syncCheckoutLabel(popup);
  }

  function syncFooterLabelsFromSnapshot(popup) {
    syncCheckoutLabel(popup);
    if (lastCartSnapshot) syncSubtotalLabel(popup, lastCartSnapshot);
  }

  function formatProgressRemainingMoney(cart, amountCents) {
    var amount = amountCents / 100;
    var lang = detectLang();
    if (cart.currency === 'SEK') {
      return (
        new Intl.NumberFormat(lang === 'sv' ? 'sv-SE' : undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount) + ' kr'
      );
    }
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: cart.currency
    }).format(amount);
  }

  var shadowObserveStates = new WeakMap();
  var upcartHostCache = null;
  var structureWiredPopups = new WeakSet();
  var layoutWiredPopups = new WeakSet();
  var footerRestoreTimers = new WeakMap();
  var footerWatchTargets = new WeakMap();
  var popupShellTargets = new WeakMap();
  var layoutReadyTimers = new WeakMap();
  var lastKnownDisplayCount = 0;
  var refreshLock = false;
  var augmentingDom = false;
  var lastFetchAt = 0;
  var lastRunRefreshAt = 0;
  var RUN_REFRESH_MIN_MS = 150;
  var FETCH_MIN_MS = 5000;
  var LAYOUT_READY_POLL_MS = 180;
  var LAYOUT_READY_MAX_MS = 10000;
  var FOOTER_RESTORE_MS = 200;
  var FOOTER_RESTORE_BUSY_MS = 350;

  function isFigmaPaused() {
    return window.__WYDE_UPCART_FIGMA_PAUSE__ === true;
  }

  function isUpcartDrawerOpen() {
    try {
      if (window.__WYDE_UPCART__ && typeof window.__WYDE_UPCART__.isDrawerOpen === 'function') {
        return window.__WYDE_UPCART__.isDrawerOpen();
      }
    } catch (_) {}
    return false;
  }

  function isPopupBusy(popup) {
    if (!popup) return false;
    var buttons = popup.querySelectorAll(
      '.upcart-internal-component-product-tile__remove-button, .upcart-internal-component-product-tile__quantity-selector button'
    );
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (!btn) continue;
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return true;
      if (btn.querySelector('[class*="loading"], [class*="spinner"], [class*="Spinner"]')) return true;
    }
    return false;
  }

  function cartDisplayCount(popup) {
    if (lastCartSnapshot && lastCartSnapshot.item_count > 0) return lastCartSnapshot.item_count;
    if (!popup) return 0;
    var headerCount = popup.querySelector('.wyde-upcart-figma-header-count');
    if (headerCount) {
      var parsedHeader = parseInt(String(headerCount.textContent || '0'), 10);
      if (parsedHeader > 0) return parsedHeader;
    }
    var h3 = popup.querySelector('.upcart-internal-header h3[data-upcart-chunk="header-title-content"]');
    if (h3) {
      var raw = String(h3.textContent || '').trim();
      var headerMatch = raw.match(/(\d+)\s*$/);
      if (headerMatch) {
        var parsedRaw = parseInt(headerMatch[1], 10);
        if (parsedRaw > 0) return parsedRaw;
      }
    }
    var itemsRoot = popup.querySelector('.upcart-internal-cart-items');
    if (itemsRoot) {
      var rows = itemsRoot.querySelectorAll('.upcart-internal-cart-item');
      if (rows.length > 0) return rows.length;
      if (itemsRoot.children.length > 0) return 1;
    }
    return 0;
  }

  function rowLooksLoading(row) {
    if (!row) return true;
    if (row.getAttribute('aria-busy') === 'true') return true;
    if (
      row.querySelector(
        '[class*="loading"], [class*="Loading"], [class*="spinner"], [class*="Spinner"], [class*="skeleton"], [class*="Skeleton"], [class*="shimmer"], [class*="Shimmer"], [class*="pulse"], [class*="Pulse"]'
      )
    ) {
      return true;
    }
    var img = row.querySelector('img[src]:not([src=""])');
    var productLink = row.querySelector('a[href*="/products/"]');
    var titleEl = row.querySelector(
      '[class*="productName"], [class*="ProductName"], [class*="product-title"], [class*="ProductTitle"], [class*="title"], [class*="Title"]'
    );
    var titleText = titleEl ? String(titleEl.textContent || '').trim() : '';
    if (img || productLink) return false;
    if (titleText.length > 2) return false;
    return true;
  }

  function hasReadyCartLines(popup) {
    if (!popup) return false;
    var rows = popup.querySelectorAll('.upcart-internal-cart-items .upcart-internal-cart-item');
    if (!rows.length) return false;
    for (var i = 0; i < rows.length; i++) {
      if (!rowLooksLoading(rows[i])) return true;
    }
    return false;
  }

  function shouldDeferLayout(popup) {
    if (!popup) return false;
    if (cartDisplayCount(popup) <= 0) return false;
    return !hasReadyCartLines(popup);
  }

  function shouldDeferAugmentation(popup) {
    return shouldDeferLayout(popup);
  }

  function unwrapScrollHost(popup) {
    var body = findUpcartBody(popup);
    if (!body) return;
    var host = body.querySelector(':scope > .wyde-upcart-figma-scroll-host');
    if (!host) return;
    while (host.firstChild) {
      body.insertBefore(host.firstChild, host);
    }
    if (host.parentNode) host.parentNode.removeChild(host);
    layoutWiredPopups.delete(popup);
  }

  function syncPopupShellTargets(popup) {
    if (!popup) return;
    var count = cartDisplayCount(popup);
    if (lastKnownDisplayCount === 0 && count > 0) {
      layoutWiredPopups.delete(popup);
      structureWiredPopups.delete(popup);
      footerWatchTargets.delete(popup);
    }
    lastKnownDisplayCount = count;
    var body = findUpcartBody(popup);
    var footer = findUpcartFooter(popup);
    var prev = popupShellTargets.get(popup) || {};
    if ((prev.body && body && prev.body !== body) || (prev.footer && footer && prev.footer !== footer)) {
      layoutWiredPopups.delete(popup);
      structureWiredPopups.delete(popup);
      footerWatchTargets.delete(popup);
    }
    popupShellTargets.set(popup, { body: body, footer: footer });
  }

  function scheduleLayoutWhenReady(popup) {
    if (!popup || !shouldDeferLayout(popup)) return;
    if (layoutReadyTimers.has(popup)) return;
    var started = Date.now();
    function poll() {
      layoutReadyTimers.delete(popup);
      if (!popup.isConnected) return;
      if (!shouldDeferLayout(popup)) {
        invalidateStaleWiring(popup);
        wireDiscount(popup);
        if (isStructureCurrent(popup)) structureWiredPopups.add(popup);
        if (lastCartSnapshot) {
          augmentingDom = true;
          try {
            applyProgressFromCart(popup, lastCartSnapshot);
            injectCartLineSizes(popup, lastCartSnapshot);
            applyFooterExtras(popup);
            paintUpcartShell(popup);
          } finally {
            augmentingDom = false;
          }
        }
        return;
      }
      if (Date.now() - started > LAYOUT_READY_MAX_MS) return;
      layoutReadyTimers.set(popup, setTimeout(poll, LAYOUT_READY_POLL_MS));
    }
    layoutReadyTimers.set(popup, setTimeout(poll, LAYOUT_READY_POLL_MS));
  }

  function isStructureCurrent(popup) {
    var footer = findUpcartFooter(popup);
    if (!footer) return true;
    var discountRoot = footer.querySelector('.upcart-internal-discount-code');
    if (!discountRoot) return true;
    return (
      discountRoot.getAttribute('data-wyde-upcart-discount-wired') === '1' ||
      !!discountRoot.querySelector('.wyde-upcart-figma-discount-outer')
    );
  }

  function invalidateStaleWiring(popup) {
    if (!isStructureCurrent(popup)) structureWiredPopups.delete(popup);
  }

  function runCriticalSetup(popup) {
    if (!popup) return;
    syncPopupShellTargets(popup);
    unwrapScrollHost(popup);
    updateSettlingState(popup);
    syncFooterLabelsFromSnapshot(popup);
    watchFooterTotals(popup);
    if (shouldDeferAugmentation(popup)) {
      scheduleLayoutWhenReady(popup);
      return;
    }
    invalidateStaleWiring(popup);
    wireDiscount(popup);
  }

  function applyFooterExtras(popup) {
    if (!popup) return;
    ensureShippingRow(popup);
    ensureUsp(popup);
    ensurePaymentIcons(popup);
    ensureDiscountRowPadding(popup);
    refreshDiscountCopy(popup);
    if (lastCartSnapshot) syncFooterTotals(popup, lastCartSnapshot);
  }

  function footerNeedsRestore(popup) {
    if (!popup) return false;
    if (shouldDeferAugmentation(popup)) return false;
    if (!isStructureCurrent(popup)) return true;
    if (!lastCartSnapshot || lastCartSnapshot.item_count <= 0) return false;
    var footer = findUpcartFooter(popup);
    if (!footer) return false;
    var pack = strings();
    var checkout = findCheckoutButton(popup);
    if (checkout && checkout.textContent !== pack.checkout_label) return true;
    if (!footer.querySelector('.wyde-amp-figma-pay-icons')) return true;
    if (!footer.querySelector('.wyde-amp-figma-usp')) return true;
    if (!footer.querySelector('[data-wyde-upcart-shipping]')) return true;
    return false;
  }

  function resolveWydeUpcartCssHref() {
    if (window.__WYDE_UPCART_FIGMA_ASSET_CSS__) return window.__WYDE_UPCART_FIGMA_ASSET_CSS__;
    var nodes = document.getElementsByTagName('script');
    for (var i = nodes.length - 1; i >= 0; i--) {
      var src = nodes[i].src || '';
      if (src.indexOf('wyde-upcart-figma.js') !== -1) {
        return src.replace('wyde-upcart-figma.js', 'wyde-upcart-figma.css');
      }
    }
    return '';
  }

  function getUpcartHost() {
    try {
      if (
        upcartHostCache &&
        upcartHostCache.isConnected !== false &&
        upcartHostCache.shadowRoot &&
        document.documentElement.contains(upcartHostCache)
      ) {
        return upcartHostCache;
      }
    } catch (_) {}
    upcartHostCache = null;

    var ids = ['upCart', 'upcart', 'UpCart', 'UPCART'];
    for (var a = 0; a < ids.length; a++) {
      try {
        var el = document.getElementById(ids[a]);
        if (el && el.shadowRoot) {
          upcartHostCache = el;
          return el;
        }
      } catch (e) {}
    }
    var walk =
      typeof document.body !== 'undefined' && document.body
        ? document.body.getElementsByTagName('*')
        : [];
    for (var k = 0; k < walk.length; k++) {
      try {
        var cand = walk[k];
        var sr =
          cand && typeof Element !== 'undefined' && cand.shadowRoot != null ? cand.shadowRoot : null;
        if (!sr) continue;
        if (sr.querySelector('[id*="UpcartPopup"], [id*="CartPopup"], [data-upcart]')) {
          upcartHostCache = cand;
          return cand;
        }
      } catch (e2) {}
    }
    return null;
  }

  function getUpcartShadowRoot(host) {
    var h = host || getUpcartHost();
    return h && h.shadowRoot ? h.shadowRoot : null;
  }

  function ensureShadowStylesheet(shadowRoot) {
    var href = resolveWydeUpcartCssHref();
    if (!href || !shadowRoot) return;
    if (shadowRoot.querySelector('link[data-wyde-upcart-figma-styles="1"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-wyde-upcart-figma-styles', '1');
    shadowRoot.appendChild(link);
  }

  function bindShadowMutationObserver(shadowRoot) {
    if (!shadowRoot || shadowObserveStates.get(shadowRoot)) return;
    shadowObserveStates.set(shadowRoot, true);
    new MutationObserver(function () {
      if (refreshLock || augmentingDom) return;
      scheduleRun();
    }).observe(shadowRoot, { subtree: true, childList: true });
  }

  function getPopup() {
    var sr = getUpcartShadowRoot();
    if (!sr) return null;
    return (
      sr.getElementById('UpcartPopup') ||
      sr.getElementById('CartPopup') ||
      sr.querySelector('[id*="UpcartPopup"], [id*="CartPopup"]')
    );
  }

  function iconHtml(kind) {
    var src = USP_IMG[kind];
    if (!src) return '';
    return (
      '<img class="wyde-amp-figma-usp__icon wyde-amp-figma-usp__icon--img" src="' +
      src +
      '" alt="" width="24" height="24" loading="lazy" decoding="async"/>'
    );
  }

  function buildUspHtml() {
    var pack = strings();
    return pack.usp
      .map(function (row) {
        return (
          '<div class="wyde-amp-figma-usp__item">' +
          iconHtml(row.icon) +
          '<span class="wyde-amp-figma-usp__text">' +
          row.text +
          '</span></div>'
        );
      })
      .join('');
  }

  function enhanceHeader(popup, cart) {
    var h3 = popup.querySelector('.upcart-internal-header h3[data-upcart-chunk="header-title-content"]');
    if (!h3) return;

    var count = cart && cart.item_count != null ? cart.item_count : null;
    if (h3.getAttribute('data-wyde-upcart-header') === '1') {
      var countEl = h3.querySelector('.wyde-upcart-figma-header-count');
      if (countEl && count != null) countEl.textContent = String(count);
      return;
    }

    var raw = String(h3.textContent || '').trim();
    var m = raw.match(/^(.+?)(\s*[•·]\s*)(\d+)\s*$/);
    if (!m) return;
    h3.setAttribute('data-wyde-upcart-header', '1');
    h3.innerHTML =
      '<span class="wyde-upcart-figma-header-title">' +
      m[1] +
      '</span><span class="wyde-upcart-figma-header-sep">' +
      m[2] +
      '</span><span class="wyde-upcart-figma-header-count">' +
      (count != null ? count : m[3]) +
      '</span>';
  }

  function updateSettlingState(popup) {
    if (!popup) return;
    popup.classList.toggle(
      'wyde-upcart-figma--settling',
      isFigmaPaused() || isPopupBusy(popup)
    );
  }

  function scheduleFooterRestore(popup) {
    if (!popup) return;
    updateSettlingState(popup);
    var prev = footerRestoreTimers.get(popup);
    if (prev) clearTimeout(prev);
    var delay =
      isFigmaPaused() || isPopupBusy(popup) ? FOOTER_RESTORE_BUSY_MS : FOOTER_RESTORE_MS;
    footerRestoreTimers.set(
      popup,
      setTimeout(function () {
        footerRestoreTimers.delete(popup);
        if (isFigmaPaused() || isPopupBusy(popup)) {
          scheduleFooterRestore(popup);
          return;
        }
        updateSettlingState(popup);
        augmentingDom = true;
        try {
          applyFooterExtras(popup);
          if (!isPopupBusy(popup)) paintUpcartShell(popup);
        } finally {
          augmentingDom = false;
        }
      }, delay)
    );
  }

  function ensureUsp(popup) {
    var footer =
      popup.querySelector('.upcart-footer') ||
      popup.querySelector('[class*="Footer__"][class*="upcart-footer"]');
    if (!footer) return;
    var hasItems =
      (lastCartSnapshot && lastCartSnapshot.item_count > 0) ||
      !!popup.querySelector('.upcart-internal-cart-items .upcart-internal-cart-item');
    var existing = footer.querySelector('.wyde-amp-figma-usp');
    if (!hasItems) {
      if (existing && lastCartSnapshot && lastCartSnapshot.item_count > 0) return;
      if (existing) existing.remove();
      return;
    }
    if (existing) return;
    var discount = footer.querySelector('.upcart-internal-discount-code');
    var wrap = document.createElement('div');
    wrap.className = 'wyde-amp-figma-usp';
    wrap.setAttribute('role', 'region');
    wrap.setAttribute('aria-label', detectLang() === 'sv' ? 'Förmåner' : 'Benefits');
    wrap.innerHTML = buildUspHtml();
    if (discount && discount.parentNode) {
      discount.parentNode.insertBefore(wrap, discount);
    } else {
      footer.insertBefore(wrap, footer.firstChild);
    }
  }

  function wireDiscount(popup) {
    var root = popup.querySelector('.upcart-internal-discount-code');
    if (!root) return;
    if (root.querySelector('.wyde-upcart-figma-discount-outer')) {
      if (!root.getAttribute('data-wyde-upcart-discount-wired')) {
        root.setAttribute('data-wyde-upcart-discount-wired', '1');
      }
      return;
    }
    if (root.getAttribute('data-wyde-upcart-discount-wired')) return;
    var form =
      root.querySelector('form.upcart-internal-discount-code__form') ||
      root.querySelector('form[class*="discount-code"]') ||
      root.querySelector('form');
    if (!form) return;
    root.setAttribute('data-wyde-upcart-discount-wired', '1');
    var pack = strings();
    var outer = document.createElement('div');
    outer.className = 'wyde-upcart-figma-discount-outer';
    var title = document.createElement('div');
    title.className = 'wyde-upcart-figma-discount-title';
    title.textContent = pack.discount_title;
    title.setAttribute('role', 'button');
    title.setAttribute('tabindex', '0');
    title.setAttribute('aria-expanded', 'false');
    form.classList.add('wyde-upcart-figma-discount-form');
    var inp =
      root.querySelector('.upcart-internal-discount-code__input') ||
      root.querySelector('input[class*="discount-code"]');
    if (inp) inp.setAttribute('placeholder', pack.discount_placeholder);

    root.insertBefore(outer, root.firstChild);
    outer.appendChild(title);
    outer.appendChild(form);

    function toggle() {
      var open = outer.classList.toggle('wyde-upcart-figma-coupon-open');
      title.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    title.addEventListener('click', function (e) {
      e.preventDefault();
      toggle();
    });
    title.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  }

  function ensureFooterSummaryClass(footer) {
    if (!footer) return;
    var mapped = footer.querySelector('[class*="cartSummarySection"]');
    if (mapped) {
      mapped.classList.add('wyde-upcart-figma-footer-summary');
      return;
    }
    if (footer.querySelector('.wyde-upcart-figma-footer-summary')) return;
    var btn =
      footer.querySelector('a.upcart-checkout-button') ||
      footer.querySelector('a[class*="checkout-button"]');
    if (!btn) return;
    var walk = btn.parentElement;
    while (walk && walk !== footer && walk.parentElement !== footer) {
      walk = walk.parentElement;
    }
    if (!walk || walk === footer) return;
    walk.classList.add('wyde-upcart-figma-footer-summary');
  }

  function ensureShippingRow(popup) {
    var footer =
      popup.querySelector('.upcart-footer') ||
      popup.querySelector('[class*="Footer__"][class*="upcart-footer"]');
    if (!footer) return;
    ensureFooterSummaryClass(footer);
    var section =
      footer.querySelector('[class*="cartSummarySection"]') ||
      footer.querySelector('.wyde-upcart-figma-footer-summary');
    if (!section) return;

    var row = footer.querySelector('[data-wyde-upcart-shipping]');
    if (!row) {
      row = document.createElement('div');
      row.className = 'wyde-upcart-figma-shipping-row';
      row.setAttribute('data-wyde-upcart-shipping', '1');
      row.innerHTML =
        '<span class="wyde-upcart-figma-shipping-label"></span><span class="wyde-upcart-figma-shipping-value"></span>';
    }

    /* Keep outside cartSummarySection — injecting into UpCart's summary root breaks subtotal/checkout updates. */
    if (row.parentNode === section) {
      section.parentNode.insertBefore(row, section);
    } else if (!row.parentNode || row.parentNode !== section.parentNode) {
      section.parentNode.insertBefore(row, section);
    }
  }

  function updateShipping(popup, freeShippingUnlocked) {
    ensureShippingRow(popup);
    var row = popup.querySelector('[data-wyde-upcart-shipping]');
    if (!row) return;
    var pack = strings();
    var lbl = row.querySelector('.wyde-upcart-figma-shipping-label');
    var val = row.querySelector('.wyde-upcart-figma-shipping-value');
    if (lbl) lbl.textContent = pack.shipping_label;
    if (!val) return;
    if (freeShippingUnlocked) {
      val.textContent = pack.shipping_free;
      val.classList.add('wyde-upcart-figma-shipping-value--free');
    } else {
      val.textContent = pack.shipping_at_checkout;
      val.classList.remove('wyde-upcart-figma-shipping-value--free');
    }
  }

  function ensureFooterExtrasHost(popup) {
    var footer = findUpcartFooter(popup);
    if (!footer) return null;
    var host = footer.querySelector(':scope > .wyde-upcart-figma-extras-host');
    if (!host) {
      host = document.createElement('div');
      host.className = 'wyde-upcart-figma-extras-host';
      host.setAttribute('data-wyde-upcart-extras', '1');
    }
    if (host.parentNode !== footer) footer.appendChild(host);
    return host;
  }

  function ensurePaymentIcons(popup) {
    var footer = findUpcartFooter(popup);
    if (!footer) return;
    var hasItems =
      (lastCartSnapshot && lastCartSnapshot.item_count > 0) ||
      !!popup.querySelector('.upcart-internal-cart-items .upcart-internal-cart-item');
    if (!hasItems) return;
    var extrasHost = ensureFooterExtrasHost(popup);
    if (!extrasHost || extrasHost.querySelector('.wyde-amp-figma-pay-icons')) return;
    ensureFooterSummaryClass(footer);
    var row = document.createElement('div');
    row.className = 'wyde-amp-figma-pay-icons';
    row.setAttribute('aria-hidden', 'true');
    var P = PAY_CARD_IMG;
    function payMark(title, src, w, h) {
      var width = w != null ? w : 32;
      var height = h != null ? h : 20;
      return (
        '<img class="wyde-amp-figma-pay__img" src="' +
        src +
        '" alt="' +
        title +
        '" width="' +
        width +
        '" height="' +
        height +
        '" loading="lazy" decoding="async"/>'
      );
    }
    row.innerHTML =
      '<div class="wyde-amp-figma-pay-icons__row">' +
      payMark('Visa', P.visa) +
      payMark('American Express', P.amex) +
      payMark('Mastercard', P.mc) +
      payMark('Apple Pay', P.apple) +
      payMark('Google Pay', P.google) +
      payMark('PayPal', P.paypal) +
      payMark('Shop Pay', P.shop) +
      '</div>';
    extrasHost.appendChild(row);
  }

  function ensureProgressWrap(rewards) {
    var wrap = rewards.querySelector('.wyde-amp-figma-progress-wrap');
    if (wrap) return wrap;
    wrap = document.createElement('div');
    wrap.className = 'wyde-amp-figma-progress-wrap';
    wrap.innerHTML =
      '<div class="wyde-amp-figma-rewards-text" aria-live="polite"></div>' +
      '<div class="wyde-amp-figma-progress-track">' +
      '<div class="wyde-amp-figma-progress-fill"></div>' +
      '</div>';
    rewards.insertBefore(wrap, rewards.firstChild);
    return wrap;
  }

  function removeProgressWrap(rewards) {
    rewards.removeAttribute('data-wyde-upcart-native-hidden');
    var w = rewards.querySelector('.wyde-amp-figma-progress-wrap');
    if (w && w.parentNode) w.parentNode.removeChild(w);
  }

  function applyProgressFromCart(popup, cart) {
    var rewardsNodes = popup.querySelectorAll('.upcart-internal-rewards.upcart-public-rewards');
    if (!rewardsNodes.length) {
      delete popup.dataset.wydeUpcartFigmaRewards;
      return;
    }

    if (!cart || !cart.currency) {
      for (var x = 0; x < rewardsNodes.length; x++) {
        removeProgressWrap(rewardsNodes[x]);
      }
      delete popup.dataset.wydeUpcartFigmaRewards;
      return;
    }

    var thresh = thresholdFor(cart.currency);
    if (thresh == null || thresh <= 0) {
      for (var y = 0; y < rewardsNodes.length; y++) {
        removeProgressWrap(rewardsNodes[y]);
      }
      delete popup.dataset.wydeUpcartFigmaRewards;
      return;
    }

    var subtotal = cartValueForFreeShipping(cart);
    var remaining = thresh - subtotal;
    var lang = detectLang();
    var pack = COPY[lang] || COPY.en;

    for (var i = 0; i < rewardsNodes.length; i++) {
      var rewards = rewardsNodes[i];
      rewards.setAttribute('data-wyde-upcart-native-hidden', '1');
      var wrap = ensureProgressWrap(rewards);
      var textEl = wrap.querySelector('.wyde-amp-figma-rewards-text');
      var fillEl = wrap.querySelector('.wyde-amp-figma-progress-fill');

      if (remaining <= 0) {
        wrap.classList.add('wyde-amp-figma-progress-wrap--complete');
        if (textEl) textEl.innerHTML = pack.progressDone;
      } else {
        wrap.classList.remove('wyde-amp-figma-progress-wrap--complete');
        var money = formatProgressRemainingMoney(cart, remaining);
        if (textEl && pack.progressRemainingHtml)
          textEl.innerHTML = pack.progressRemainingHtml(money);
      }

      var pct = Math.min(100, Math.max(0, (subtotal / thresh) * 100));
      if (fillEl) fillEl.style.width = pct + '%';
    }
    popup.dataset.wydeUpcartFigmaRewards = '1';
  }

  function sizeLabelFromLineItem(item) {
    if (!item) return '';
    var opts = item.options_with_values;
    if (opts && opts.length) {
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        if (o && o.name && /^size$/i.test(String(o.name).trim()) && o.value) {
          return String(o.value);
        }
      }
    }
    var vt = item.variant_title;
    if (vt && String(vt).trim() && String(vt).trim().toLowerCase() !== 'default title') {
      return String(vt).trim();
    }
    return '';
  }

  function injectCartLineSizes(popup, cart) {
    if (!cart || !cart.items || !hasReadyCartLines(popup)) return;
    var pack = strings();
    var sizeLine = pack.sizeLine || function (l) {
      return 'Size: ' + l;
    };

    var rows = popup.querySelectorAll('.upcart-internal-cart-item');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (rowLooksLoading(row)) continue;
      var kp = row.querySelector('.upcart-internal-cart-items__key-value-pair');
      if (!kp) continue;

      var label = sizeLabelFromLineItem(cart.items[i]);
      if (!label) {
        var raw = String(kp.textContent || '').trim();
        var sizeMatch = raw.match(/(?:Size|Storlek):\s*(.+)/i);
        if (sizeMatch) label = sizeMatch[1].trim();
      }
      if (!label) continue;

      kp.classList.add('wyde-amp-figma-cart-line-size');
      kp.textContent = sizeLine(label);
    }
  }

  function findUpcartBody(popup) {
    return (
      popup.querySelector('.upcart-cart-body') ||
      popup.querySelector('[class*="CartPreview__body__"]') ||
      popup.querySelector('.styles_CartPreview__empty__body__')
    );
  }

  function findUpcartFooter(popup) {
    return (
      popup.querySelector('.upcart-footer') ||
      popup.querySelector('[class*="styles_Footer__"]') ||
      popup.querySelector('[class*="Footer__"][class*="upcart-footer"]')
    );
  }

  function paintUpcartShell(popup) {
    function paint(el, color) {
      if (!el) return;
      el.style.setProperty('background-color', color, 'important');
      el.style.setProperty('background', color, 'important');
    }

    var card =
      popup.querySelector('[class*="CartPreview__card__"]') ||
      popup.querySelector('.styles_CartPreview__card__');
    paint(card, '#f2f2f2');

    paint(
      popup.querySelector('.upcart-internal-header.upcart-public-header') ||
        popup.querySelector('.upcart-public-header'),
      '#ffffff'
    );

    var footer =
      popup.querySelector('.upcart-footer') ||
      popup.querySelector('[class*="Footer__"][class*="upcart-footer"]');
    paint(footer, '#f2f2f2');

    paint(
      popup.querySelector('.upcart-cart-body') ||
        popup.querySelector('[class*="CartPreview__body__"]'),
      '#ffffff'
    );

    popup.querySelectorAll('.wyde-amp-figma-progress-wrap').forEach(function (w) {
      paint(w, '#ffffff');
    });
    popup.querySelectorAll('.upcart-internal-rewards.upcart-public-rewards').forEach(function (r) {
      if (popup.dataset.wydeUpcartFigmaRewards === '1') paint(r, '#ffffff');
    });

    popup.classList.add('wyde-upcart-figma--active');
  }

  var fetchTimer = null;
  var FETCH_SETTLE_MS = 50;
  var FETCH_SETTLE_BUSY_MS = 180;

  function applyCachedAugmentation(popup, cart) {
    if (!popup || !cart) return;
    augmentingDom = true;
    try {
      enhanceHeader(popup, cart);
      syncFooterTotals(popup, cart);
      if (shouldDeferAugmentation(popup)) {
        scheduleLayoutWhenReady(popup);
        return;
      }
      applyProgressFromCart(popup, cart);
      if (!isPopupBusy(popup)) {
        injectCartLineSizes(popup, cart);
      }
      applyFooterExtras(popup);

      if (!cart.currency) {
        updateShipping(popup, false);
        paintUpcartShell(popup);
        return;
      }
      var thresh = thresholdFor(cart.currency);
      if (thresh == null || thresh <= 0) {
        updateShipping(popup, false);
        paintUpcartShell(popup);
        return;
      }
      var remaining = thresh - cartValueForFreeShipping(cart);
      updateShipping(popup, remaining <= 0);
      paintUpcartShell(popup);
    } finally {
      augmentingDom = false;
    }
  }

  function fetchCartAugmentation(popup) {
    if (!popup || !isUpcartDrawerOpen()) return;
    if (isPopupBusy(popup)) {
      scheduleFetch(popup);
      return;
    }
    lastFetchAt = Date.now();
    var originFetch =
      typeof window.__WYDE_ORIGIN_FETCH__ === 'function'
        ? window.__WYDE_ORIGIN_FETCH__
        : window.fetch.bind(window);
    originFetch(cartJsUrl(), { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        applyCachedAugmentation(popup, cart);
      })
      .catch(function () {});
  }

  function scheduleFetch(popup, force) {
    if (!popup || !isUpcartDrawerOpen()) return;
    if (fetchTimer) clearTimeout(fetchTimer);
    var delay = isFigmaPaused() || isPopupBusy(popup) ? FETCH_SETTLE_BUSY_MS : FETCH_SETTLE_MS;
    fetchTimer = setTimeout(function () {
      fetchTimer = null;
      if (!popup.isConnected || !isUpcartDrawerOpen()) return;
      if (!force && lastCartSnapshot && Date.now() - lastFetchAt < FETCH_MIN_MS) return;
      fetchCartAugmentation(popup);
    }, delay);
  }

  var runTimer = null;
  function refreshDiscountCopy(popup) {
    var el = popup.querySelector('.wyde-upcart-figma-discount-title');
    if (!el) return;
    el.textContent = strings().discount_title;
    var inp =
      popup.querySelector('.upcart-internal-discount-code__input') ||
      popup.querySelector('input[class*="discount-code"]');
    if (inp) inp.setAttribute('placeholder', strings().discount_placeholder);
  }

  function ensureDiscountRowPadding(popup) {
    var footer = findUpcartFooter(popup);
    if (!footer) return;
    var pad = window.matchMedia('(min-width: 750px)').matches ? '30px' : '20px';
    footer.querySelectorAll(
      '.upcart-internal-cart-summary, [class*="cartSummaryDiscount"], [class*="DiscountRow"], [class*="discountRow"], [class*="cartDiscount"]'
    ).forEach(function (row) {
      row.style.setProperty('padding-left', pad, 'important');
      row.style.setProperty('padding-right', pad, 'important');
      row.style.setProperty('box-sizing', 'border-box', 'important');
      row.style.setProperty('width', '100%', 'important');
    });
  }

  function watchFooterTotals(popup) {
    var footer = findUpcartFooter(popup);
    if (!footer) return;
    if (footerWatchTargets.get(popup) === footer) return;
    footerWatchTargets.set(popup, footer);
    new MutationObserver(function () {
      if (syncingFooterTotals || refreshLock) return;
      if (!footerNeedsRestore(popup)) return;
      scheduleFooterRestore(popup);
      if (!lastCartSnapshot) scheduleFetch(popup);
    }).observe(footer, { childList: true, subtree: true });
  }

  function runStructure(popup) {
    invalidateStaleWiring(popup);
    if (structureWiredPopups.has(popup)) return;
    wireDiscount(popup);
    if (isStructureCurrent(popup)) structureWiredPopups.add(popup);
  }

  function runRefresh(popup) {
    if (!popup || !isUpcartDrawerOpen()) return;
    var now = Date.now();
    if (refreshLock) return;
    if (now - lastRunRefreshAt < RUN_REFRESH_MIN_MS) {
      scheduleRun();
      return;
    }
    refreshLock = true;
    lastRunRefreshAt = now;
    try {
      runCriticalSetup(popup);
      ensureShadowStylesheet(getUpcartShadowRoot());
      if (!shouldDeferAugmentation(popup)) {
        runStructure(popup);
        if (footerNeedsRestore(popup)) scheduleFooterRestore(popup);
      }
      if (!lastCartSnapshot) {
        scheduleFetch(popup, true);
      } else if (
        shouldDeferAugmentation(popup) ||
        !structureWiredPopups.has(popup) ||
        footerNeedsRestore(popup)
      ) {
        applyCachedAugmentation(popup, lastCartSnapshot);
      }
    } finally {
      refreshLock = false;
    }
  }

  function run() {
    var host = getUpcartHost();
    var sr = getUpcartShadowRoot(host);
    if (!sr) return;
    ensureShadowStylesheet(sr);
    bindShadowMutationObserver(sr);
    var popup = getPopup();
    if (!popup) return;
    runRefresh(popup);
  }

  function scheduleRun() {
    if (runTimer) clearTimeout(runTimer);
    runTimer = setTimeout(run, isFigmaPaused() ? 200 : 150);
  }

  var docObs = new MutationObserver(function () {
    if (upcartHostCache && upcartHostCache.isConnected !== false) return;
    scheduleRun();
  });
  docObs.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRun);
  } else {
    scheduleRun();
  }

  window.addEventListener('resize', scheduleRun, { passive: true });
  ['cart:updated', 'amp:cart:updated', 'wyde:upcart:cart-change', 'wyde:upcart:figma-resume'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      scheduleRun();
      scheduleFetch(getPopup(), true);
    });
  });
})();
